import FloatingVue from "floating-vue";
import Vue from "vue";
function floatingVuePlugin() {
  Vue.use(FloatingVue);
}
export {
  floatingVuePlugin as default
};
